import { Reveal } from "@components/ui";

const stats = [
  { value: "99.5%", label: "Supply Reliability" },
  { value: "60–120 min", label: "Emergency SLA" },
  { value: "10,000+", label: "Units Serviced" },
  { value: "100+", label: "Commercial Clients" },
  { value: "100%", label: "DCD & ESMA Compliant" },
  { value: "24/7", label: "Customer Support" },
];

export function StatsSection() {
  return (
    <section className="w-full bg-white pb-12 md:pb-16 lg:pb-[120px] pt-0 px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col items-center gap-10 md:gap-14">
        <Reveal direction="up">
          <h2 className="text-[28px] md:text-[36px] lg:text-[48px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1] text-center">
            Numbers That Speak for Themselves
          </h2>
        </Reveal>

        <Reveal direction="up" delay={100} className="w-full">
          <div className="rounded-[24px] overflow-hidden bg-gradient-to-r from-[#122d63] to-[#1a3f7a]">
            {/* Desktop: single row */}
            <div className="hidden lg:grid grid-cols-6">
              {stats.map((stat, i) => (
                <div
                  key={stat.label}
                  className={`flex flex-col items-center justify-center text-center py-10 px-4 ${
                    i < stats.length - 1 ? "border-r border-white/10" : ""
                  }`}
                >
                  <span className="text-[28px] xl:text-[32px] font-bold text-white tracking-[-0.04em] font-albert-sans leading-none">
                    {stat.value}
                  </span>
                  <span className="mt-2 text-[13px] xl:text-[14px] text-white/60 tracking-[0.03em] font-medium font-albert-sans uppercase">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            {/* Mobile/Tablet: 2x3 or 3x2 grid */}
            <div className="lg:hidden grid grid-cols-2 sm:grid-cols-3">
              {stats.map((stat, i) => (
                <div
                  key={stat.label}
                  className={`flex flex-col items-center justify-center text-center py-7 px-4 ${
                    i % 2 !== 0 ? "" : "border-r border-white/10"
                  } ${
                    i < 4 ? "border-b border-white/10" : ""
                  } sm:border-r sm:border-white/10 ${
                    i % 3 === 2 ? "sm:!border-r-0" : ""
                  } ${
                    i < 3 ? "sm:border-b sm:border-white/10" : "sm:border-b-0"
                  }`}
                >
                  <span className="text-[24px] md:text-[28px] font-bold text-white tracking-[-0.04em] font-albert-sans leading-none">
                    {stat.value}
                  </span>
                  <span className="mt-1.5 text-[12px] md:text-[13px] text-white/60 tracking-[0.03em] font-medium font-albert-sans uppercase">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
